import type { ToolId } from './workspace-config';

export const PHONE_SHELL_CONTENT_OFFSET_CLASS = 'pt-[calc(env(safe-area-inset-top)+4.75rem)]';

export function shouldHidePhoneShellChrome({
    isMobile,
    toolId: _toolId,
}: {
    isMobile: boolean;
    toolId: ToolId;
}): boolean {
    return isMobile;
}
